import { Injectable } from '@angular/core';
import { ISearchService } from './ISearchService';
import { Observable, of } from 'rxjs';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class HistorySearchService implements ISearchService{
  items: string[] = [];

  constructor(private storageService: StorageService) { }

  search(term: string): Observable<string[]> {
    return of(this.items.filter(i => i.startsWith(term)));
  }

  async init() {
    const items = await this.storageService.get('history');
    if (items) {
      this.items = items;
    }
    console.log('load history', this.items);
  }

  add(item: string) {
    this.items = this.items.filter(i => i !== item);
    this.items.unshift(item);
    this.items = this.items.slice(0, 500);
    this.storageService.set('history', this.items);

  }

  remove(item: string) {
    this.items = this.items.filter(i => i !== item);
    this.storageService.set('history', this.items);
  }

  present(item: string) {
    return this.items.includes(item);
  }
}
